/* PRM — premium interactions */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 760;
  function isMobile() { return window.innerWidth <= MOBILE_BREAKPOINT; }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.prm-reveal:not(.is-revealed)');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Pill tabs ---------- */
  function initPillTabs() {
    document.querySelectorAll('[data-prm-tabs]').forEach(function (root) {
      if (root.dataset.prmTabsInit) return;
      root.dataset.prmTabsInit = '1';
      var pills = root.querySelectorAll('[data-prm-tab]');
      var panels = root.querySelectorAll('[data-prm-panel]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var target = pill.getAttribute('data-prm-tab');
          pills.forEach(function (p) {
            var active = p.getAttribute('data-prm-tab') === target;
            p.classList.toggle('is-active', active);
            p.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-prm-panel') !== target;
          });
        });
      });
    });
  }

  /* ---------- Video play overlay ---------- */
  function initVideoPlay() {
    document.querySelectorAll('[data-prm-video]').forEach(function (root) {
      if (root.dataset.prmVideoInit) return;
      root.dataset.prmVideoInit = '1';
      var video = root.querySelector('video');
      var button = root.querySelector('[data-prm-play]');
      if (!video || !button) return;
      button.addEventListener('click', function () {
        video.muted = false;
        video.play();
        button.style.opacity = '0';
        button.style.pointerEvents = 'none';
      });
      video.addEventListener('pause', function () {
        button.style.opacity = '';
        button.style.pointerEvents = '';
      });
    });
  }

  /* ---------- Header on scroll ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-prm-header]');
    if (!header) return;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Mobile auto-swipe with dots ---------- */
  function initAutoSwipe() {
    document.querySelectorAll('[data-prm-autoswipe]').forEach(function (track) {
      if (track.dataset.prmSwipeInit) return;
      track.dataset.prmSwipeInit = '1';

      var items = track.children;
      if (!items.length) return;

      // Find or create dots container
      var dotsContainer = track.parentElement.querySelector('[data-prm-dots]');
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        for (var i = 0; i < items.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          if (i === 0) dot.classList.add('is-active');
          (function (idx) {
            dot.addEventListener('click', function () {
              scrollToIndex(idx, true);
            });
          })(i);
          dotsContainer.appendChild(dot);
        }
      }

      var current = 0;
      var rotateMs = parseInt(track.dataset.prmAutoswipe, 10) || 4500;
      var timer = null;
      var pausedUntil = 0;

      function scrollToIndex(idx, userTriggered) {
        if (idx < 0) idx = items.length - 1;
        if (idx >= items.length) idx = 0;
        current = idx;
        var item = items[idx];
        if (!item) return;
        var left = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
        track.scrollTo({ left: left, behavior: 'smooth' });
        updateDots();
        if (userTriggered) pausedUntil = Date.now() + 8000;
      }

      function updateDots() {
        if (!dotsContainer) return;
        Array.prototype.forEach.call(dotsContainer.children, function (dot, idx) {
          dot.classList.toggle('is-active', idx === current);
        });
      }

      function tick() {
        if (!isMobile()) return;
        if (Date.now() < pausedUntil) return;
        scrollToIndex(current + 1, false);
      }

      function start() {
        stop();
        timer = setInterval(tick, rotateMs);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      // Sync current index when user scrolls
      var scrollTimeout;
      track.addEventListener('scroll', function () {
        pausedUntil = Date.now() + 5000;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          // Find nearest item to scroll center
          var center = track.scrollLeft + track.clientWidth / 2;
          var nearest = 0;
          var nearestDist = Infinity;
          for (var i = 0; i < items.length; i++) {
            var itemCenter = items[i].offsetLeft + items[i].offsetWidth / 2;
            var dist = Math.abs(itemCenter - center);
            if (dist < nearestDist) { nearestDist = dist; nearest = i; }
          }
          current = nearest;
          updateDots();
        }, 100);
      }, { passive: true });

      track.addEventListener('touchstart', function () { pausedUntil = Date.now() + 8000; }, { passive: true });

      // Start only on mobile
      function evaluate() {
        if (isMobile()) start();
        else stop();
      }
      evaluate();
      window.addEventListener('resize', evaluate);
    });
  }

  /* ---------- Init ---------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    initReveal();
    initPillTabs();
    initVideoPlay();
    initHeaderScroll();
    initAutoSwipe();
  }

  ready(init);
  document.addEventListener('shopify:section:load', init);
})();
